import React, {useState} from 'react'
import { Card, Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { HiLocationMarker } from 'react-icons/hi';
import { BiTimeFive } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa';
import { GrClose } from 'react-icons/gr';
import { AvCheckbox, AvCheckboxGroup, AvField, AvForm, AvRadio, AvRadioGroup } from 'availity-reactstrap-validation';
import InputRange from 'react-input-range';
import PopularBox from './PopularBox';
import OpportunitieList from './OpportunitieList';


export default function JobListing() {

    const [showbox, setShowbox] = useState(false);

    const toggleBtn = () =>{
        setShowbox(true);
    }
    const closeFilter = () =>{
        setShowbox(false);
    }
    return (
        <>
            <section className='banner_strip'>
                <h1>Opportunities</h1>
            </section>
            <div className='job-page'>
            <Container fluid style={{padding:0}}>
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Opportunities</li>
            </ol>
            </nav>
            </Container>
                <Container fluid>
                    <AvForm>
                        <Row>
                            <Col md={12} className="p-0">
                                <div className='job-listing'>
                                    <button type='button' onClick={toggleBtn} className='filter_btn'>
                                       <FaFilter /> Filter
                                    </button>
                                   <div className='job-li'>
                                    <OpportunitieList for={true}/>
                                   </div>
                                </div>
                            </Col>
                            {/* <Col md={4}>
                                <div className={showbox == false ? 'filter-box':'filter-box active'}>
                                    <button type='button' onClick={closeFilter} className='filter-close-btn'>
                                     <GrClose />
                                    </button>
                                    <Row>

                                        <Col lg={12}>
                                            <Card className='f-card filter-card'>
                                                <h5>Select Course</h5>
                                                <AvField type="select" name="select">
                                                    <option value="1">Any category</option>
                                                    <option value="2">Web Designer</option>
                                                    <option value="3">Web Developer</option>
                                                    <option value="4">Graphic Designer</option>
                                                    <option value="5">App Developer</option>
                                                    <option value="6">UI &amp; UX Expert</option>
                                                </AvField>

                                            </Card>
                                        </Col>
                                        <Col lg={12}>
                                            <Card className='f-card filter-card'>
                                                <h5>Select Location</h5>
                                                <AvField type="select" name="select">
                                                    <option value="1">Any category</option>
                                                    <option value="2">Web Designer</option>
                                                    <option value="3">Web Developer</option>
                                                    <option value="4">Graphic Designer</option>
                                                    <option value="5">App Developer</option>
                                                    <option value="6">UI &amp; UX Expert</option>
                                                </AvField>
                                            </Card>
                                        </Col>
                                        <Col lg={12}>
                                            <Card className='f-card filter-card'>
                                                <h5>Select Qualification</h5>
                                                <AvField type="select" name="select">
                                                    <option value="1">Any category</option>
                                                    <option value="2">Web Designer</option>
                                                    <option value="3">Web Developer</option>
                                                    <option value="4">Graphic Designer</option>
                                                    <option value="5">App Developer</option>
                                                    <option value="6">UI &amp; UX Expert</option>
                                                </AvField>
                                            </Card>
                                        </Col>


                                    </Row>
                                </div>
                            </Col> */}
                        </Row>
                    </AvForm>
                </Container>

            </div>
            {/* <div className='section-10'>
                <Row>
                    <Col lg={12}>
                        <PopularBox />
                    </Col>
                </Row>
            </div> */}
        </>

    )
}
